import 'twin.macro';
import React from 'react';
import tw from 'twin.macro';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Title } from './Title';

interface ImportFileStepProps {
  step: number;
  title: string;
  description?: string;
  isOpen: boolean;
  isSuccess?: boolean;
  resetButton?: {
    onClick: () => void;
    label: string;
  };
  children: React.ReactNode;
}

export function StepLayout(props: ImportFileStepProps) {
  const { step, title, description, isOpen, isSuccess, resetButton, children } =
    props;
  const isDisabled = !isOpen && !isSuccess;

  return (
    <div
      tw="bg-white border border-neutral-quiet rounded-lg p-4 flex flex-col gap-4"
      css={[isDisabled && tw`opacity-60`]}
    >
      <div>
        <div tw="flex items-center justify-between">
          <Title disabled={!isOpen} success={isSuccess} step={step}>
            {title}
          </Title>
          {!isOpen && resetButton && (
            <Button outlined onClick={resetButton.onClick} small>
              {resetButton.label}
            </Button>
          )}
        </div>
        {isOpen && description && (
          <div tw="mt-2">
            <p tw="text-neutral-moderate text-base">{description}</p>
          </div>
        )}
      </div>
      {isOpen && children}
    </div>
  );
}
